import { Observable } from 'rxjs';

export interface HrDesignationLists {
  list: Array<any>,
  count: number | string
}

export abstract class HrData {
  abstract getDesignation(): Observable<HrDesignationLists>;
  abstract getDesignationEmployee(id: number | string): Observable<HrDesignationLists>;
  abstract getEmployeeByEmpCode(id: number | string): Observable<HrDesignationLists>;
}
